import React, { Component } from "react";
import "./index.less";
import { colors, colorMap } from "../../helpers/helpers";
class Grid extends Component {
  generateItemStyle(index) {
    const { xAxisScales, yAxisScales } = this.props.gridData;
    const gridColumn = (index + 1) % xAxisScales || xAxisScales;
    const gridRow = yAxisScales - Math.floor(index / xAxisScales);
    return {
      gridColumn,
      gridRow,
    };
  }

  generateBlocks() {
    const { xAxisScales, yAxisScales, colorScheme } = this.props.gridData;
    const { gridData, values } = this.props;
    const arr = Array.from({ lenght: yAxisScales }, () => []);
    for (let i = 0; i < yAxisScales; i++) {
      arr[i] = gridData.gridBlocks.slice(
        i * xAxisScales,
        (i + 1) * xAxisScales
      );
    }
    return arr.reverse();
  }

  generateRatio(item, values) {
    const ratio =
      values[item.number - 1]?.ratio.replaceAll("%", "") &&
      values[item.number - 1]?.ratio.replaceAll("%", "") !== "0" &&
      item.name.text
        ? `${values[item.number - 1]?.ratio.replaceAll("%", "")}%`
        : "";
    return ratio ? `(${ratio})` : "";
  }
  render() {
    const { gridData, values, personInfo } = this.props;
    const { xAxisScales, yAxisScales, colorScheme } = this.props.gridData;
    const blocks = this.generateBlocks();
    return (
      <div className="axis-grid-container">
        <div className={"grid-list"} style={{ display: "flex" }}>
          {blocks.map((block) => {
            return (
              <div
                className="grid-list-line"
                style={{
                  height: `calc((100% - ${
                    (yAxisScales - 1) * 5
                  }px) / ${yAxisScales})`,
                }}
              >
                {block.map((item, index) => (
                  <div
                    className={"grid-talent-item"}
                    style={{
                      background: item.backColor || "#ccc",
                      width: `calc((100% - ${
                        (xAxisScales - 1) * 5
                      }px) / ${xAxisScales})`,
                      // ...this.generateItemStyle(index),
                    }}
                  >
                    <div
                      className="grid-talent-item-anchor"
                      style={{
                        background:
                          colorScheme === "#000000"
                            ? colorMap[
                                colors[`${xAxisScales}-${yAxisScales}`][
                                  item.number - 1
                                ]
                              ]
                            : colorScheme,
                      }}
                    >
                      {item.customNumber}
                    </div>
                    <div
                      style={{ width: "100%" }}
                      className="item-title-wrapper"
                    >
                      <input
                        disabled="disabled"
                        type="text"
                        className="item-title"
                        value={
                          this.generateRatio(item, values) + item.name.text
                        }
                        style={{ color: item.name.fontColor }}
                      />
                    </div>
                    {personInfo.number == item.customNumber ? (
                      <div style={{ width: "100%", padding: "0 5px" }}>
                        <div
                          style={{
                            width: "120px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src={personInfo.headSculpture}
                            alt=""
                            style={{
                              width: "24px",
                              height: "24px",
                              marginRight: "4px",
                            }}
                          />
                          <div style={{ width: "calc(100% - 28px)" }}>
                            {personInfo.personName}
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                ))}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default Grid;
